// extracted by mini-css-extract-plugin
module.exports = {"root":"EditMenuServicesPanel_root__Bi1ii","form":"EditMenuServicesPanel_form__24pg4","title":"EditMenuServicesPanel_title__3rP0e"};